var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOtherBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 11.8714V15.8714C4.5 16.7014 5.17 17.3714 6 17.3714C6.83 17.3714 7.5 16.7014 7.5 15.8714V11.8714C7.5 11.0414 6.83 10.3714 6 10.3714C5.17 10.3714 4.5 11.0414 4.5 11.8714ZM10.5 11.8714V15.8714C10.5 16.7014 11.17 17.3714 12 17.3714C12.83 17.3714 13.5 16.7014 13.5 15.8714V11.8714C13.5 11.0414 12.83 10.3714 12 10.3714C11.17 10.3714 10.5 11.0414 10.5 11.8714ZM4 22.3714H20C20.83 22.3714 21.5 21.7014 21.5 20.8714C21.5 20.0414 20.83 19.3714 20 19.3714H4C3.17 19.3714 2.5 20.0414 2.5 20.8714C2.5 21.7014 3.17 22.3714 4 22.3714ZM16.5 11.8714V15.8714C16.5 16.7014 17.17 17.3714 18 17.3714C18.83 17.3714 19.5 16.7014 19.5 15.8714V11.8714C19.5 11.0414 18.83 10.3714 18 10.3714C17.17 10.3714 16.5 11.0414 16.5 11.8714ZM11.07 1.86141L3.17 6.02141C2.76 6.23141 2.5 6.66141 2.5 7.12141C2.5 7.81141 3.06 8.37141 3.75 8.37141H20.26C20.94 8.37141 21.5 7.81141 21.5 7.12141C21.5 6.66141 21.24 6.23141 20.83 6.02141L12.93 1.86141C12.35 1.55141 11.65 1.55141 11.07 1.86141Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherBank);
export default __webpack_public_path__ + "static/media/other_bank.4eb2a60959f45cd92478e125d35a7bdc.svg";
export { ForwardRef as ReactComponent };